import React, { useEffect, useMemo, useRef, useState } from 'react'
import ErrorMessage from 'components/common/ErrorMessage';
import toast from 'react-hot-toast';
import Api from "services/api"
import moment from 'moment-timezone';
import PhoneInput from 'components/common/PhoneInput';
import Swal from 'sweetalert2'
import ConfirmDataStep from './ConfirmDataStep';
import { Controller, FormProvider, set, useController, useForm, useFormContext, useWatch } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { hospitalSelector } from 'slices/hospitalSlice';
import { setError } from 'slices/hospitalSlice';
import { Spinner } from 'reactstrap';
import { fetchCitys } from 'slices/citySlice';
import { fetchStates } from 'slices/stateSlice';
import { stateSelector } from 'slices/stateSlice';
import { citySelector } from 'slices/citySlice';
import { Select } from 'components/common/Select';
import { DialogTitle, Switch } from '@mui/material';
import { accountsSelector } from 'slices/accountSlice';
import { fetchTypes } from 'slices/typeSlice';
import { fetchLanguages } from 'slices/languageSlice';
// import { updateAppointment } from 'slices/appointmentSlice';
import { addAppointment, addRequest, updateAppointment, updateRequest } from 'slices/appointmentSlice';
import { fetchAppointments } from 'slices/appointmentSlice';
import { fetchSingleClientSubject } from 'slices/appointmentSlice';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import { typesSelector } from 'slices/typeSlice';
import { setDynamicFields } from 'slices/accountSlice';
import { fetchMainClients } from 'slices/typeSlice';
import InfoMessage from 'components/common/InfoMessage';
import { fetchCustomRate, clearCustomRate } from 'slices/accountSlice';
import AfterAppointmentModal from './AfterAppointmentModal';
import UpdateEmailConfirmationModal from './UpdateEmailConfirmationModal';
import { BootstrapDialog } from 'components/languageTiers/AddLanguageTiers';
import { useNavigate } from 'react-router-dom';
import { fetchCountries } from 'slices/countrySlice';
import { fetchTimezone } from 'slices/timezoneSlice';
import { USA } from "constants/common";
import ListInterpreters from './ListInterpreters';

const DEFAULT_APPOINTMENT_TYPE = "In Person";
const apiService = new Api();

export const timeToMinutes = (time) => {
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes;
};

const genderOptions = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'nonbinary', label: 'Nonbinary' },
]
const appointmentTypes = [
  {
    label: "In Person",
    value: "In Person"
  },
  {
    label: "Video Remote Interpretation",
    value: "Video Remote Interpretation"
  },
  {
    label: "Telephonic",
    value: "Telephonic"
  },
  {
    label: "OPI On Demand",
    value: "OPI On Demand"
  }

]

const LANGUAGE_NOT_LISTED_OPTION = { value: "not_listed", label: "Language not listed" };

//#region ACCOUNTS SELCTION STEP
const AccountStep = ({ control, errors, dispatch, item, accounts, setConfirmData, mainAccount, setMainAccount, subClient, setSubclient, allSubAccounts, setAllSubAccounts, setValue, isEditMode, isClientPortal, isAccountLocked }) => {

  const methods = useController({
    control,
    name: "account_id",
    rules: { required: true },
  });
  const { onChange } = methods.field;


  // #region Accounts dropdown
  const [allAccounts, setAllAccounts] = React.useState([]);

  // useEffect(() => {
  //   if (item?.accounts) {
  //     setMainAccount({
  //       label: item?.accounts?.user?.name || "",
  //       value: item?.accounts?.id || ""
  //     })

  //   }
  // }, [item?.accounts])

  useEffect(() => {
  if (item?.accounts?.sub_accounts?.length > 0) {
    setAllSubAccounts(item.accounts.sub_accounts);
  }
}, [item?.accounts?.sub_accounts]);

  // const filteredLoadOptions = async (inputValue, loadedOptions, { page }) => {

  //   const result = await dispatch(fetchTypes(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true))
  //   setAllAccounts(result?.data)
  //   return {
  //     options: result.data.map((item) => ({
  //       value: item.id,
  //       label: item.name,
  //     })),
  //     hasMore: page !== result?.last_page ? true : false,
  //     additional: {
  //       page: page + 1,
  //     },
  //   };
  // };
  const prevSearchRef = useRef("");

  const filteredLoadOptions = async (inputValue, loadedOptions, { page }) => {

    if (inputValue !== prevSearchRef.current) {
      page = 1;
      prevSearchRef.current = inputValue;
    }

    const result = await dispatch(fetchTypes(
      page,
      { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue, type: "interpretation" },
      true,
      true
    ));

    setAllAccounts(result?.data);

    return {
      options: result.data.map((item) => ({
        value: item.id,
        label: item.name,
        data: item,
      })),
      hasMore: page < result.last_page,
      additional: { page: page + 1 },
    };
  };

  //#endregion


  // #region Sub Accounts dropdown

  const filteredSubAccount = React.useMemo(() =>
    allSubAccounts?.map(item => {
      const object = {
        label: item?.name,
        value: item?.id,
      }
      return object
    }), [allSubAccounts]);


  const filteredAccounts = React.useMemo(() => {
    return accounts?.map(item => {
      const object = {
        label: item?.name,
        value: item?.id,
        data: item,
      }
      return object
    })
  }, [accounts]);

  useEffect(() => {
    if (item?.accounts?.name) {
      setAllSubAccounts(accounts?.find(account => account?.id == item?.accounts?.id)?.sub_accounts)
    }
  }, [item?.accounts?.name, accounts]);

  // useEffect(() => {
  //   if (item?.subclient?.subaccount_name && item?.subclient?.id) {
  //     setSubclient({
  //       label: item?.subclient?.subaccount_name || "",
  //       value: item?.subclient?.id || ""
  //     })
  //   } else {
  //     setSubclient({})
  //   }
  // }, [item?.subclient])

  //#endregion



  useEffect(() => {
    setConfirmData((prevData) => ({ ...prevData, subClientName: subClient?.label }))
    setConfirmData((prevData) => ({ ...prevData, subClientId: subClient?.value }))

  }, [subClient]);

  useEffect(() => {

    return () => {
      // setMainAccount({
      //   label: "",
      //   value: ""
      // })
    }
  }, [])


  return (
    <>
      <div className='step_cards step_1'>
        <h2>Select a Client</h2>

        <div className="row-primary">
          <h2>Client Account *</h2>

          <Controller
            name="account_id"
            control={control}
            rules={{
              required: "Please select a Account"
            }}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <AsyncPaginate
                  menuPlacement='auto'
                  styles={{
                    ...selectCustomStyles,
                  }}
                  value={mainAccount || {}}
                  defaultOptions={item?.accounts?.id ? filteredAccounts : {}}
                  loadOptions={filteredLoadOptions}
                  isClearable={!isClientPortal}
                  escapeClearsValue
                  isDisabled={isAccountLocked || isClientPortal}
                  onChange={(obj) => {
                    setMainAccount(obj)
                    setAllSubAccounts(obj != null ? obj?.data?.sub_accounts : [])

                    const foundAccount = obj != null ? obj?.data : null;
                    const timezoneObj = foundAccount?.timezone ?? null;
                    const newTimezone = timezoneObj ? { value: timezoneObj.id, label: timezoneObj.display_name } : null;

                    setConfirmData((prevData) => ({ ...prevData, clientName: obj?.label }))
                    setConfirmData((prevData) => ({ ...prevData, clientId: obj?.value }))
                    setConfirmData((prevData) => ({ ...prevData, timezone: newTimezone }))
                    field.onChange(obj?.value);
                    setValue("sub_account_id", "")
                    setSubclient({})
                  }}
                  additional={{
                    page: item?.accounts?.id ? 2 : 1,
                  }}
                />
                {
                  errors?.account_id?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.account_id?.message} />
                  </div>
                }
              </div>
            }
          />
        </div>

        <div className="row-primary">
          <h2>Client Sub Account</h2>
          <Controller
            name="sub_account_id"
            control={control}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <Select
                  onStateChanges={setSubclient}
                  name="sub_account_id"
                  options={filteredSubAccount || []}
                  {...field}
                  value={mainAccount ? (subClient?.value ? subClient : (filteredSubAccount?.find((opt) => field.value === opt.value) || null)) : null}
                  isDisabled={isAccountLocked}
                />
                {errors?.sub_account_id?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.sub_account_id?.message} />
                  </div>
                }
              </div>
            }
          />
        </div>

      </div>
    </>
  )
}
//#endregion

//#region TYPE STEP
const TypeStep = ({ control, item, isEditMode, popupType, allSubAccounts, subClient, setSubclient, subAccountLoading }) => {
  // Switch work 
  const methods = useController({
    control,
    name: "type",
    rules: { required: true },
    // defaultValue: DEFAULT_APPOINTMENT_TYPE
  });

  const { setValue } = methods;

  const visibleAppointmentTypes = React.useMemo(() => {
    if (popupType === "client-portal" || popupType === "edit-request" || popupType === "from-request") {
      return appointmentTypes
        .filter((type) => type.value !== "OPI On Demand")
        .map((type) =>
          type.value === "Telephonic"
            ? { ...type, label: "Telephonic" }
            : type
        );
    }
    return appointmentTypes;
  }, [popupType]);



  // Switch work 

  const subAccountOptions = React.useMemo(() => {
    return allSubAccounts?.map((sub) => ({
      label: sub?.name || sub?.subaccount_name || "",
      value: sub?.id,
    })) || [];
  }, [allSubAccounts]);

  return (
    <>
      <div className='step_cards step_2'>

        {(popupType === "client-portal" || popupType === "edit-request") && (
          <div className="row-primary mt-4">
            <h2>Client Sub Account</h2>
            <Controller
              name="sub_account_id"
              control={control}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <Select
                    onStateChanges={(selected) => {
                      setSubclient(selected || {});
                    }}
                    name="sub_account_id"
                    options={subAccountOptions}
                    {...field}
                    value={field.value ? subAccountOptions?.find((opt) => opt.value === field.value) : null}
                    loading={subAccountLoading}
                    placeholder={subAccountLoading ? "Loading sub accounts..." : "Select Sub Account"}
                    isDisabled={isEditMode}
                  />
                </div>
              )}
            />
          </div>
        )}
        <h2>Appointment Type</h2>

        <div className='w-100 ps-3'>
          <Controller
            name="type"
            control={control}
            render={({ field }) => {
              return visibleAppointmentTypes?.map(type => (
                <div key={type.value} className="row-primary align-items-center flex-row">
                  <Switch checked={type.value === field.value} onChange={() => field.onChange(type.value)} disabled={isEditMode} />
                  <label
                    htmlFor={type.value}
                    onClick={() => { if (!isEditMode) field.onChange(type.value); }}
                    style={{ cursor: isEditMode ? 'not-allowed' : 'pointer' }}
                  >
                    {type?.label}
                  </label>
                </div>
              ))
            }
            }
          />

          {/* {(popupType === "client-portal" || popupType === "edit-request") && (
            <div className="row-primary mt-4">
              <h2>Client Sub Account</h2>
              <Controller
                name="sub_account_id"
                control={control}
                render={({ field }) => (
                  <div style={{ width: "100%" }}>
                    <Select
                      onStateChanges={(selected) => {
                        setSubclient(selected || {});
                      }}
                      name="sub_account_id"
                      options={subAccountOptions}
                      {...field}
                      value={field.value ? subAccountOptions?.find((opt) => opt.value === field.value) : null}
                      loading={subAccountLoading}
                      placeholder={subAccountLoading ? "Loading sub accounts..." : "Select Sub Account"}
                      isDisabled={isEditMode}
                    />
                  </div>
                )}
              />
            </div>
          )} */}
        </div>
      </div>
    </>
  )
}
//#endregion

//#region DATE AND TIME
const DateTimeStep = ({ dispatch, setConfirmData, languageState, setLanguageState, timezoneState, setTimezoneState, item, clientData, isEditMode , popupType}) => {
  console.log(item, "itemssss");
  const { control, formState: { errors }, clearErrors, watch, setValue, getValues } = useFormContext();
  const type = useWatch({ control, name: "custom_pricing" });
  const { custom_rate } = useSelector(accountsSelector);
  const startTime = watch("start_time");
  const endTime = watch("end_time");
  const estimatedDuration = watch("estimated_duration");
  const mileage = useWatch({ control, name: "mileage" });
  const mileage_rate = useWatch({ control, name: "mileage_rate" });
  const travel_hours = useWatch({ control, name: "travel_hours" });
  const travel_rate = useWatch({ control, name: "travel_rate" });
  const duration_rate = useWatch({ control, name: "duration_rate" });
  const discount = useWatch({ control, name: "discount" });
  const min_duration = useWatch({ control, name: "min_duration" });
  const estimated_duration_unit = useWatch({ control, name: "estimated_duration_unit" });
  const timezoneID = watch("timezone_id");
  const account_id = watch("account_id");
  const isReadOnly = isEditMode || popupType === "edit-request";

  const noStandardRate =
    !!clientData?.clientId &&
    !!languageState?.value &&
    !!watch("subject") &&
    !!startTime &&
    !!endTime &&
    custom_rate?.found === false;

  useEffect(() => {
    if (noStandardRate && watch("custom_pricing") !== 1) {
      setValue("custom_pricing", 1);
    }
  }, [noStandardRate]);

  const ALL_SUBJECTS = [
    { value: "general", label: "General" },
    { value: "medical", label: "Medical" },
    { value: "legal", label: "Legal" },
    { value: "court", label: "Court" }
  ];
  const [clientSubjects, setClientSubjects] = useState(ALL_SUBJECTS);
  const [subjectDisabled, setSubjectDisabled] = useState(false);
  const [subjectLoading, setSubjectLoading] = useState(false);
  const hasInitializedDurationUnit = useRef(false);
  const hasManuallySelectedTimezoneRef = useRef(false);
  const previousClientIdRef = useRef(null);

  // Old Subject state management
  // useEffect(() => {
  //   let active = true;
  //   const account_id = watch("account_id");
  //   if (account_id) {
  //     // dispatch(fetchSingleClientSubject(account_id)).then((subjects) => {
  //     //   if (!active) return;
  //     //   if (subjects?.length > 0) {
  //         // setClientSubjects(subjects);
  //         const currentSubject = getValues("subject");
  //         if (currentSubject) {
  //           const isValidSubject = ALL_SUBJECTS.some((opt) => opt.value === currentSubject);
  //           if (!isValidSubject) {
  //             setValue("subject", "");
  //             setConfirmData((prev) => ({ ...prev, Subject: "" }));
  //           }
  //         }
  //     //   } else {
  //     //     setClientSubjects([]);
  //     //     const currentSubject = getValues("subject");
  //     //     if (currentSubject) {
  //     //       setValue("subject", "");
  //     //       setConfirmData((prev) => ({ ...prev, Subject: "" }));
  //     //     }
  //     //   }
  //     // });
  //   } else {
  //     if (active) {
  //     setClientSubjects([]);
  //     setValue("subject", "");
  //     setConfirmData((prev) => ({ ...prev, Subject: "" }));
  //   }
  //   }
  //   return () => {
  //     active = false;
  //   };
  // }, [watch("account_id")]);
  
  // NEW Subject state management
  useEffect(() => {
    let active = true;

    const loadSubjects = async (currentAccountId) => {
      setSubjectLoading(true);
      setSubjectDisabled(true);
      setClientSubjects([]);

      if (!currentAccountId) {
        if (!active) return;
        setClientSubjects(ALL_SUBJECTS);
        setSubjectDisabled(false);
        setSubjectLoading(false);
        setValue("subject", "");
        setConfirmData((prev) => ({ ...prev, Subject: "" }));
        return;
      }

      const subjects = await dispatch(fetchSingleClientSubject(currentAccountId));
      if (!active) return;

      if (subjects?.length === 1) {
        const onlySubject = subjects[0];
        const selected = ALL_SUBJECTS.find((opt) => opt.value === onlySubject.value) || {
          value: onlySubject.value,
          label: onlySubject.label || onlySubject.value.charAt(0).toUpperCase() + onlySubject.value.slice(1).replace(/_/g, ' '),
        };

        setClientSubjects([selected]);
        setSubjectDisabled(true);
        setValue("subject", selected.value);
        setConfirmData((prev) => ({ ...prev, Subject: selected.label }));
      } else {
        setClientSubjects(ALL_SUBJECTS);
        setSubjectDisabled(false);

        if (!subjects?.length) {
          if (getValues("subject")) {
            setValue("subject", "");
            setConfirmData((prev) => ({ ...prev, Subject: "" }));
          }
        }
      }

      setSubjectLoading(false);
    };

    loadSubjects(account_id);

    return () => {
      active = false;
    };
  }, [account_id]);

  const filterUnit = [
    {
      label: "Hour",
      value: "hour"
    },
    {
      label: "Minute",
      value: "minute"
    },
  ]

  const subjectOptions = [
    { label: "General", value: "general" },
    { label: "Medical (Non Court)", value: "medical_non_court" },
    { label: "Legal", value: "legal" },
    { label: "Court", value: "court" },
  ];

  // Function to calculate end time
  const calculateEndTime = (startTime, duration, unit = "minutes") => {
    if (!startTime || !duration) return "";
    const startMoment = moment(startTime, "HH:mm");
    return startMoment.add(parseInt(duration, 10), unit).format("HH:mm");
  };

  // Update end time when estimated duration changes
  useEffect(() => {
    if (startTime && estimatedDuration) {
      const unit = estimated_duration_unit === "hour" ? "hours" : "minutes";
      setValue("end_time", calculateEndTime(startTime, estimatedDuration, unit));
    }
  }, [startTime, estimatedDuration, estimated_duration_unit, setValue]);


  // old timeset useEffect
  // useEffect(() => {

  //   const now = moment();
  //   setValue('date', now.format('YYYY-MM-DD'));
  //   setValue('start_time', now.format("HH:mm"));

  //   // Use current 'type' to decide duration unit and value
  //   if (watch("type") === "In Person") {
  //     setValue("estimated_duration", 1); // 1 hour
  //     setValue("estimated_duration_unit", "hour");
  //   } else {
  //     setValue("estimated_duration", 15); // 15 minutes
  //     setValue("estimated_duration_unit", "minute");
  //   }

  // }, []);

  // new timeset useEffect
  useEffect(() => {
    const now = moment();
    const currentType = getValues("type");
    const currentDate = getValues("date");
    const currentStartTime = getValues("start_time");
    const currentDuration = getValues("estimated_duration");
    const currentDurationUnit = getValues("estimated_duration_unit");
    const defaultDurationUnit = currentType === "In Person" ? "hour" : "minute";
    const defaultDuration = defaultDurationUnit === "hour" ? 1 : 15;

    if (!currentDate) {
      setValue('date', now.format('YYYY-MM-DD'));
    }

    if (!currentStartTime) {
      setValue('start_time', now.format("HH:mm"));
    }

    if (!currentDurationUnit) {
      setValue("estimated_duration_unit", defaultDurationUnit);
    }

    if (!currentDuration) {
      setValue("estimated_duration", defaultDuration);
    }
  }, [getValues, setValue]);


  useEffect(() => {
    if (!estimated_duration_unit) {
      return;
    }

    if (!hasInitializedDurationUnit.current) {
      hasInitializedDurationUnit.current = true;
      return;
    }

    const currentDuration = getValues("estimated_duration");
    if (currentDuration === "" || currentDuration == null) {
      if (estimated_duration_unit === "minute") {
        setValue("estimated_duration", 15);
      } else if (estimated_duration_unit === "hour") {
        setValue("estimated_duration", 1);
      }
    }
  }, [estimated_duration_unit, setValue, getValues]);

  const [filterCountries, setfilterCountries] = useState({
    label: "",
    value: ""
  })

  // useEffect(() => {
  //   if (item?.subject) {
  //     setValue("subject", item.subject);

  //     const selected = subjectOptions.find(
  //       (opt) => opt.value === item.subject
  //     );

  //     setConfirmData((prev) => ({
  //       ...prev,
  //       Subject: selected?.label,
  //     }));
  //   }
  // }, [item?.subject]);

  // useEffect(() => {
  //   if (item?.subject && clientSubjects.length > 0) {
  //     setValue("subject", item.subject);

  //     const selected = clientSubjects.find(
  //       (opt) => opt.value === item.subject
  //     );

  //     setConfirmData((prev) => ({
  //       ...prev,
  //       Subject: selected?.label,
  //     }));
  //   }
  // }, [item?.subject, clientSubjects]);
  useEffect(() => {
    if (!item?.subject) {
      return;
    }

    const currentSubject = getValues("subject");
    if (currentSubject) {
      return;
    }

    const formattedLabel = item.subject.charAt(0).toUpperCase() + item.subject.slice(1).replace(/_/g, ' ');
    const selected = clientSubjects.find((opt) => opt.value === item.subject);

    if (!selected) {
      setClientSubjects((prev) => {
        if (prev?.some((opt) => opt.value === item.subject)) return prev;
        return [...prev, { label: formattedLabel, value: item.subject }];
      });
    }

    setValue("subject", item.subject);
    setConfirmData((prev) => ({
      ...prev,
      Subject: selected?.label || formattedLabel,
    }));
  }, [item?.subject, clientSubjects, setClientSubjects, setValue, setConfirmData, getValues]);

  // useEffect(() => {
  //   const currentLanguageId = getValues("language_id");
  //   if (item?.language && !currentLanguageId) {
  //     setLanguageState({
  //       label: item?.language?.name || "",
  //       value: item?.language?.id || ""
  //     });
  //   }
  // }, [item?.language, getValues, setLanguageState]);

  const subjectValue = watch("subject");
  const apptType = watch("type");

  const rateSignature = useMemo(() => {
    if (!clientData?.clientId || !languageState?.value || !subjectValue || !startTime || !endTime || apptType === "Telephonic") {
      return null;
    }
    return [clientData.clientId, languageState.value, subjectValue, startTime, endTime, timezoneID, apptType].join("|");
  }, [clientData?.clientId, languageState?.value, subjectValue, startTime, endTime, timezoneID, apptType]);

//New Get Rate UseEffect
  useEffect(() => {
    if (isEditMode) return;
    if (!rateSignature) return;
    
    if (getValues("_rate_signature") === rateSignature) return;
    
    let active = true;
    
    (async () => {
      const data = await dispatch(
        fetchCustomRate(
          1,
          {
            client_id: clientData.clientId,
            language_id: languageState.value,
            subject: subjectValue,
            start_time: startTime,
            end_time: endTime,
            timezone_id: timezoneID,
            type: apptType,
          },
          true,
          false
        )
      );

      if (!active) return;

      setValue("duration_rate", data?.rate ?? "");
      setValue(
        "min_duration",
        data?.duration != null ? Number(Number(data.duration).toFixed(2)) : ""
      );
      setValue("_rate_signature", rateSignature);
    })();

    return () => {
      active = false;
    };
  }, [rateSignature]);

  //Old Get Rate UseEffect
  // useEffect(() => {
  //   if (clientData?.clientId && languageState?.value && watch("subject") && startTime && endTime && watch("type") != "Telephonic") {
  //     dispatch(
  //       fetchCustomRate(
  //         1,
  //         {
  //           client_id: clientData.clientId,
  //           language_id: languageState.value,
  //           subject: watch("subject"),
  //           start_time: startTime,
  //           end_time: endTime,
  //           timezone_id: timezoneID,
  //           type: watch("type"),
  //         },
  //         true,
  //         false
  //       )
  //     );
  //   }
  // }, [clientData?.clientId, languageState?.value, watch("subject"), startTime, endTime, timezoneID]);

  useEffect(() => {
    if (!timezoneID || !languageState?.value || !watch("subject")) {
      // setValue("custom_pricing", 0);
    }
  }, [timezoneID, languageState?.value, watch("subject")]);



  const filteredLanguagesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchLanguages(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
    const fetchedOptions = result.data.map(language => ({
      value: language.id,
      label: language.name,
    }));

    const hasMore = page !== result?.last_page;
    // const options = hasMore ? fetchedOptions : [...fetchedOptions, LANGUAGE_NOT_LISTED_OPTION];
    const isLastPage = !hasMore;
    const shouldShowNotListed = popupType === "client-portal";

    const options = (isLastPage && shouldShowNotListed)
      ? [...fetchedOptions, LANGUAGE_NOT_LISTED_OPTION]
      : fetchedOptions;

    return {
      options,
      hasMore,
      additional: {
        page: page + 1,
      },
    };
  };




  // useEffect(() => {
  //   if (watch("custom_pricing") !== 1) {

  //     dispatch(clearCustomRate());

  //     // Reset all pricing fields
  //     setValue("mileage", "");
  //     setValue("mileage_rate", "");
  //     setValue("mileage_total", "0.00");

  //     setValue("travel_hours", "");
  //     setValue("travel_rate", "");
  //     setValue("travel_total", "0.00");

  //     setValue("duration_rate", "");
  //     setValue("min_duration", "");
  //     setValue("session_total", "0.00");

  //     setValue("discount", "0");
  //     setValue("sub_total", "0.00");
  //     setValue("appointment_total", "0.00");
  //   }
  // }, [type]);

  const hasCustomPricingBeenOn = useRef(false);

  useEffect(() => {
    if (watch("custom_pricing") === 1) {
      hasCustomPricingBeenOn.current = true;
    } else {
      if (!hasCustomPricingBeenOn.current) {
        dispatch(clearCustomRate());
        setValue("mileage", "");
        setValue("mileage_rate", "");
        setValue("mileage_total", "0.00");
        setValue("travel_hours", "");
        setValue("travel_rate", "");
        setValue("travel_total", "0.00");
        setValue("duration_rate", "");
        setValue("min_duration", "");
        setValue("session_total", "0.00");
        setValue("discount", "0");
        setValue("sub_total", "0.00");
        setValue("appointment_total", "0.00");
      }
    }
  }, [type]);

  useEffect(() => {
    const mileageTotal = (parseFloat(mileage) || 0) * (parseFloat(mileage_rate) || 0);
    setValue("mileage_total", mileageTotal.toFixed(2));

    const travelTotal = parseFloat(travel_hours || 0) * parseFloat(travel_rate || 0);
    setValue("travel_total", travelTotal.toFixed(2));
    console.log('custom_rate?.rate', Number(custom_rate?.duration?.toFixed(2)));
    // setValue("duration_rate", custom_rate?.rate);

    // const durationRate = custom_rate?.rate_unit === 'minute'
    // ? Number(custom_rate?.rate || 0) * 60
    // : Number(custom_rate?.rate || 0);
    // setValue("duration_rate", durationRate);

    // setValue("min_duration", Number(custom_rate?.duration?.toFixed(2)));

    const sessionTotal = parseFloat(min_duration || 0) * parseFloat(duration_rate || 0);
    setValue("session_total", sessionTotal.toFixed(2));

    const subTotal = mileageTotal + travelTotal + sessionTotal;
    setValue("sub_total", subTotal.toFixed(2));

    const discountValue = subTotal * (parseFloat(discount || 0) / 100);
    const appointmentTotal = subTotal - discountValue;
    setValue("appointment_total", appointmentTotal.toFixed(2));
  }, [
    mileage,
    mileage_rate,
    travel_hours,
    travel_rate,
    duration_rate,
    min_duration,
    discount,
    // custom_rate?.rate,
    // custom_rate?.duration
  ]);


  // #region Timezone dropdown

  useEffect(() => {
    let active = true;
    const fetchAndSetUSA = async () => {
      const result = await dispatch(fetchCountries(1, { search: USA }, true, true));
      if (!active) return;
      const countries = result?.data || [];
      const usa = countries.find(c => c.name === USA);
      if (usa) {
        setfilterCountries({
          label: usa.name,
          value: usa.id,
        });
      }
    };

    fetchAndSetUSA();
    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    const currentTimezoneId = getValues("timezone_id");
    const currentClientId = clientData?.clientId;
    
    // Check if the client has changed
    const clientChanged = previousClientIdRef.current !== currentClientId && currentClientId;
    
    // Update the ref with the current client ID
    previousClientIdRef.current = currentClientId;
    
    // If client changed, reset manual selection flag and apply new client's timezone
    if (clientChanged) {
      hasManuallySelectedTimezoneRef.current = false;
      const defaultTimezoneId = clientData?.timezone?.value ?? clientData?.timezone?.id;
      const defaultTimezoneLabel = clientData?.timezone?.label ?? clientData?.timezone?.display_name;
      setTimezoneState({
        value: defaultTimezoneId,
        label: defaultTimezoneLabel,
      });
      setValue('timezone_id', defaultTimezoneId);
    } 
    // If not manually selected yet and timezone is not set, initialize from item/client data
    else if (!hasManuallySelectedTimezoneRef.current && !currentTimezoneId) {
      const defaultTimezoneId = item?.appointment_details?.timezone?.id ?? clientData?.timezone?.value;
      const defaultTimezoneLabel = item?.appointment_details?.timezone?.display_name ?? clientData?.timezone?.label;
      setTimezoneState({
        value: defaultTimezoneId,
        label: defaultTimezoneLabel,
      });
      setValue('timezone_id', defaultTimezoneId);
    }
  }, [item?.appointment_details?.timezone, clientData.timezone, clientData?.clientId, getValues, setValue, setTimezoneState]);


  // Load options function (API call to timezone endpoint)
  const filteredTimezonesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const country_id = filterCountries.value;

    const result = await dispatch(
      fetchTimezone(
        page,
        {
          pageLength: 10,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
          country_id,
        },
        true,
        true
      )
    );

    return {
      options: result.data.map(val => ({
        value: val.id,
        label: val.display_name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };

  //#endregion
  return (
    <div className="step_cards step_3">
      <div className="row-primary">
        <h2>Date *</h2>
        <Controller
          name="date"
          control={control}
          rules={{ required: "Date is required" }}
          render={({ field }) => (
            <div style={{ width: "100%" }}>
              <div className={`input-image ${isEditMode ? 'update_inp' : ''}`}>
                <input
                  type="date"
                  {...field}
                  value={field.value}
                  disabled={isReadOnly}
                  onChange={(e) =>
                    field.onChange(moment(e.target.value).format("YYYY-MM-DD"))
                  }
                />
                <img
                  src="/images/celender.png"
                  alt="celender Icon"
                  className="custom-icon"
                />
              </div>
              {errors?.date?.message && (
                <ErrorMessage text={errors.date.message} />
              )}
            </div>
          )}
        />
      </div>

      <div className="row-primary">
        <h2>Timezone</h2>
        <Controller
          name="timezone_id"
          control={control}
          rules={{ required: "Please select a Timezone" }}
          render={({ field }) => (
            <div style={{ width: "100%" }}>
              <AsyncPaginate
                styles={selectCustomStyles}
                value={timezoneState}
                loadOptions={filteredTimezonesLoadOptions}
                isClearable
                placeholder="Select Timezone"
                isDisabled={isReadOnly}
                onChange={(selected) => {
                  if (isReadOnly) return;
                  hasManuallySelectedTimezoneRef.current = true;
                  setValue("timezone_id", selected?.value);
                  setTimezoneState(selected);
                  setConfirmData((prevData) => ({ ...prevData, timezone: selected }));
                  field.onChange(selected?.value);
                }}
                additional={{ page: 1 }}
              />
              {errors?.timezone_id?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.timezone_id?.message} />
                </div>
              )}
            </div>
          )}
        />

      </div>

      <div className="row-primary">
        <h2>Start Time*</h2>
        <Controller
          name="start_time"
          control={control}
          rules={{ required: "Please select start time" }}
          render={({ field }) => (
            <div style={{ width: "100%" }}>
              <div className={`input-image ${isEditMode ? 'update_inp' : ''}`}>
                <input type="time" {...field} disabled={isReadOnly} />
                <img
                  src="/images/clock.png"
                  alt="Clock Icon"
                  className="custom-icon"
                />
              </div>
              {errors?.start_time?.message && (
                <ErrorMessage text={errors.start_time.message} />
              )}
            </div>
          )}
        />
      </div>

      <div className="row-primary est_duration">
        <h2>
          Est Duration *
        </h2>
        <div className="w-50">

          <Controller
            name={'estimated_duration_unit'}
            control={control}
            render={({ field }) =>
              <div className='select_box' style={{ width: "100%" }}>
                <Select
                  name={'estimated_duration_unit'}
                  options={filterUnit || []}
                  value={field.value ? filterUnit?.find((opt) => field.value == opt.value) : ""}
                  isClearable={false}
                  disabledSearch={true}
                  isDisabled={isReadOnly}
                  onChange={(value) => {
                    if (isReadOnly) return;
                    field.onChange(value);
                  }}
                />
              </div>
            }
          />
        </div>
        <div className="w-50">
          <Controller
            name="estimated_duration"
            control={control}
            rules={{
              required: "Please enter Estimated Duration",
              min: {
                value: estimated_duration_unit === "hour" ? 1 : 15,
                message: estimated_duration_unit === "hour"
                  ? "Duration must be at least 1 hour"
                  : "Duration must be at least 15 minutes",
              },
              max: {
                value: estimated_duration_unit === "hour" ? 24 : 1440,
                message: estimated_duration_unit === "hour"
                  ? "Duration cannot exceed 24 hours"
                  : "Duration cannot exceed 1440 minutes",
              },
              validate: (value) => {
                const numeric = Number(value);
                if (value === "") return "Please enter Estimated Duration";
                if (estimated_duration_unit === "minute") {
                  if (numeric < 15) return "Duration must be at least 15 minutes";
                  if (numeric > 1440) return "Duration cannot exceed 1440 minutes";
                }
                if (estimated_duration_unit === "hour") {
                  if (numeric < 1) return "Duration must be at least 1 hour";
                  if (numeric > 24) return "Duration cannot exceed 24 hours";
                }
                return true;
              },
            }}
            render={({ field }) => {
              const min = estimated_duration_unit === "hour" ? 1 : 15;
              const max = estimated_duration_unit === "hour" ? 24 : 1440;

              return (
                <div style={{ width: "100%" }}>
                  <input
                    className="input-in type_inp"
                    type="number"
                    {...field}
                    min={min}
                    max={max}
                    value={field.value || ""}
                    disabled={isReadOnly}
                    onChange={(e) => {
                      if (isReadOnly) return;
                      const rawValue = e.target.value;
                      if (rawValue === "") {
                        field.onChange("");
                        return;
                      }
                      const numericValue = Number(rawValue);
                      if (!Number.isNaN(numericValue)) {
                        field.onChange(numericValue);
                      }
                    }}
                  />
                  {console.log(errors, 'errorsssssss')}
                  {errors?.estimated_duration?.message && (
                    <ErrorMessage text={errors.estimated_duration.message} />
                  )}
                </div>
              );
            }}
          />
        </div>



      </div>

      <div className="row-primary" style={{ display: "none" }}>
        <h2>End Time*</h2>
        <Controller
          name="end_time"
          control={control}
          rules={{ required: "Please select End time" }}
          render={({ field }) => (
            <div style={{ width: "100%" }}>
              <div className={`input-image ${isEditMode ? 'update_inp' : ''}`}>
                <input type="time" {...field} readOnly />
                <img
                  src="/images/clock.png"
                  alt="Clock Icon"
                  className="custom-icon"
                />
              </div>
              {errors?.end_time?.message && (
                <ErrorMessage text={errors.end_time.message} />
              )}
            </div>
          )}
        />
      </div>
      <div className="row-primary">
        <h2>Language *</h2>
        <Controller
          name="language_id"
          control={control}
          rules={{
            validate: value => value ? true : "Please select a language",
          }}
          render={({ field }) => {
            const isNotListed = field.value === LANGUAGE_NOT_LISTED_OPTION.value || languageState?.value === LANGUAGE_NOT_LISTED_OPTION.value;
            return (
              <div style={{ width: "100%" }}>
                <AsyncPaginate
                  menuPlacement="auto"
                  styles={{
                    ...selectCustomStyles,
                  }}
                  value={languageState}
                  loadOptions={filteredLanguagesLoadOptions}
                  isClearable
                  escapeClearsValue
                  isDisabled={isReadOnly}
                  onChange={(obj) => {
                    if (isReadOnly) return;
                    setLanguageState(obj);
                    setConfirmData((prevData) => ({
                      ...prevData,
                      Language: obj?.value === LANGUAGE_NOT_LISTED_OPTION.value ? LANGUAGE_NOT_LISTED_OPTION.label : obj?.label,
                    }));
                    field.onChange(obj?.value);
                    if (obj?.value !== LANGUAGE_NOT_LISTED_OPTION.value) {
                      setValue('language_text', '');
                    }
                  }}
                  additional={{
                    page: 1,
                  }}
                />
                {errors?.language_id?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.language_id?.message} />
                  </div>
                )}

                {isNotListed && (
                  <div style={{ marginTop: 12 }}>
                    <Controller
                      name="language_text"
                      control={control}
                      rules={{
                        required: "Please type a language name",
                      }}
                      render={({ field: textField }) => (
                        <input
                          type="text"
                          className="input-in type_inp"
                          placeholder="Type a language name"
                          disabled={isReadOnly}
                          {...textField}
                          onChange={(e) => {
                            if (isReadOnly) return;
                            const value = e.target.value;
                            textField.onChange(value);
                            setConfirmData((prevData) => ({
                              ...prevData,
                              Language: value || LANGUAGE_NOT_LISTED_OPTION.label,
                            }));
                          }}
                        />
                      )}
                    />
                    {errors?.language_text?.message && (
                      <div style={{ marginBottom: 10 }}>
                        <ErrorMessage text={errors?.language_text?.message} />
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          }}
        />
      </div>

      <div className="row-primary">
        <h2>Subject *</h2>
        <Controller
          name="subject"
          control={control}
          rules={{
            required: "Please select a subject",
          }}
          render={({ field }) => (
            <div style={{ width: "100%" }}>
              <Select
                styles={selectCustomStyles}
                options={subjectLoading ? [] : clientSubjects}
                placeholder={subjectLoading ? "Loading subjects..." : "Select Subject"}
                value={
                  field.value
                    ? clientSubjects.find(opt => opt.value === field.value) || { label: field.value.charAt(0).toUpperCase() + field.value.slice(1).replace(/_/g, ' '), value: field.value }
                    : null
                }
                isClearable={false}
                isDisabled={isEditMode || subjectDisabled || subjectLoading}
                noOptionsMessage={() => subjectLoading ? "Loading subjects..." : "No subjects available"}
                onChange={(selected) => {
                  field.onChange(selected);
                  setConfirmData(prev => ({
                    ...prev,
                    Subject: selected?.label,
                  }));
                }}
              />
              {errors?.subject?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors.subject.message} />
                </div>
              )}
            </div>
          )}
        />
      </div>

      {((popupType !== "client-portal") && popupType !== "edit-request" && watch("type") != "Telephonic") && (
        <>
          <div className="row-primary align-items-center flex-row">
            <Switch
              checked={watch("custom_pricing") === 1}
              onChange={(e) => {
                if (isReadOnly) return;
                setValue("custom_pricing", e.target.checked ? 1 : 0);
              }}
              disabled={isReadOnly || !timezoneID || !languageState?.value || !watch("subject") || noStandardRate}
            />
            <label
              htmlFor="custom_pricing"
              onClick={() => {
                if (isReadOnly || !timezoneID || !languageState?.value || !watch("subject") || noStandardRate) return;
                setValue("custom_pricing", watch("custom_pricing") == 1 ? 0 : 1);
              }}
              style={{
                cursor: (isReadOnly || !timezoneID || !languageState?.value || !watch("subject")) ? "not-allowed" : "pointer",
                marginLeft: "8px",
                opacity: (isReadOnly || !timezoneID || !languageState?.value || !watch("subject")) ? 0.5 : 1,
              }}
            >
              Custom Appointment Pricing
            </label>
          </div>

          {watch("custom_pricing") == 1 && (
            <div className="w-100 custom_pricing">
              {/* Row 1 - Mileage */}
              <div className="row d-flex justify-content-between mb-3">
                <div className="col-md-4">
                  <div className="row-primary">
                    <h2>Mileage (km)</h2>
                  </div>
                  <Controller
                    name="mileage"
                    control={control}
                    rules={{
                      required: "Mileage is required",
                      max: { value: 99999, message: "Max 5 digits" },
                      pattern: {
                        value: /^\d{1,5}(\.\d{1,2})?$/,
                        message: "Up to 5 digits and 2 decimals allowed",
                      },
                    }}
                    render={({ field }) => (
                      <div className="input-image">
                        <input type="number" placeholder="Mileage" {...field} disabled={isReadOnly} />
                      </div>
                    )}
                  />
                  {errors.mileage?.message && (
                    <ErrorMessage text={errors.mileage.message} />
                  )}
                </div>

                <div className="col-md-4">
                  <div className="row-primary">
                    <h2>Mileage Rate</h2>
                  </div>
                  <Controller
                    name="mileage_rate"
                    control={control}
                    rules={{
                      required: "Mileage Rate is required",
                      max: { value: 99999, message: "Max 5 digits" },
                      pattern: {
                        value: /^\d{1,5}(\.\d{1,2})?$/,
                        message: "Up to 5 digits and 2 decimals allowed",
                      },
                    }}
                    render={({ field }) => (
                      <div className="input-image">
                        <input
                          type="number"
                          placeholder="Rate per km"
                          {...field}
                          disabled={isReadOnly}
                        />
                      </div>
                    )}
                  />
                  {errors.mileage_rate?.message && (
                    <ErrorMessage text={errors.mileage_rate.message} />
                  )}
                </div>

                <div className="col-md-4">
                  <div className="row-primary">
                    <h2>Mileage Total</h2>
                  </div>
                  <Controller
                    name="mileage_total"
                    control={control}
                    rules={{ required: "Mileage Total is required" }}
                    render={({ field }) => (
                      <div className="input-image">
                        <input
                          type="number"
                          placeholder="Mileage Total"
                          readOnly
                          {...field}
                        />
                      </div>
                    )}
                  />
                  {errors.mileage_total?.message && (
                    <ErrorMessage text={errors.mileage_total.message} />
                  )}
                </div>
              </div>

              {/* Row 2 - Travel */}
              <div className="row d-flex justify-content-between mb-3">
                <div className="col-md-4">
                  <div className="row-primary">
                    <h2>Travel (hrs)</h2>
                  </div>
                  <Controller
                    name="travel_hours"
                    control={control}
                    rules={{
                      required: "Travel Hours is required",
                      max: { value: 99999, message: "Max 5 digits" },
                      pattern: {
                        value: /^\d{1,5}(\.\d{1,2})?$/,
                        message: "Up to 5 digits and 2 decimals allowed",
                      },
                    }}
                    render={({ field }) => (
                      <div className="input-image">
                        <input
                          type="number"
                          placeholder="Travel Hours"
                          {...field}
                          disabled={isReadOnly}
                        />
                      </div>
                    )}
                  />
                  {errors.travel_hours?.message && (
                    <ErrorMessage text={errors.travel_hours.message} />
                  )}
                </div>

                <div className="col-md-4">

                  <div className="row-primary">
                    <h2>Travel Hourly Rate</h2>
                  </div>
                  <Controller
                    name="travel_rate"
                    control={control}
                    rules={{
                      required: "Travel Hourly Rate is required",
                      max: { value: 99999, message: "Max 5 digits" },
                      pattern: {
                        value: /^\d{1,5}(\.\d{1,2})?$/,
                        message: "Up to 5 digits and 2 decimals allowed",
                      },
                    }}
                    render={({ field }) => (
                      <div className="input-image">
                        <input
                          type="number"
                          placeholder="Rate per Hour"
                          {...field}
                          disabled={isReadOnly}
                        />
                      </div>
                    )}
                  />
                  {errors.travel_rate?.message && (
                    <ErrorMessage text={errors.travel_rate.message} />
                  )}
                </div>

                <div className="col-md-4">

                  <div className="row-primary">
                    <h2>Travel Total</h2>
                  </div>
                  <Controller
                    name="travel_total"
                    control={control}
                    render={({ field }) => (
                      <div className="input-image">
                        <input
                          type="number"
                          placeholder="Travel Total"
                          {...field}
                          readOnly
                        />
                      </div>
                    )}
                  />
                </div>
              </div>

              {/* Row 3 - Duration */}
              <div className="row d-flex justify-content-between mb-3">
                <div className="col-md-4">
                  <div className="row-primary">
                    <h2>Duration Total</h2>
                  </div>
                  <Controller
                    name="min_duration"
                    control={control}
                    rules={{
                      required: "Duration Total is required",
                      max: { value: 99999, message: "Max 5 digits" },
                      pattern: {
                        value: /^\d{1,5}(\.\d{1,2})?$/,
                        message: "Up to 5 digits and 2 decimals allowed",
                      },
                    }}
                    render={({ field }) => (
                      <div className="input-image">
                        <input
                          type="number"
                          placeholder="Min Duration"
                          {...field}
                          readOnly
                        />
                      </div>
                    )}
                  />
                  {errors.min_duration?.message && (
                    <ErrorMessage text={errors.min_duration.message} />
                  )}
                </div>

                <div className="col-md-4">
                  <div className="row-primary">
                    <h2>Rate (per hr)</h2>
                  </div>
                  <Controller
                    name="duration_rate"
                    control={control}
                    rules={{
                      required: "Rate (per hr) is required",
                      max: { value: 99999, message: "Max 5 digits" },
                      pattern: {
                        value: /^\d{1,5}(\.\d{1,2})?$/,
                        message: "Up to 5 digits and 2 decimals allowed",
                      },
                    }}
                    render={({ field }) => (
                      <div className="input-image">
                        <input
                          type="number"
                          placeholder="Rate per Hour"
                          {...field}
                          disabled={isReadOnly}
                          // readOnly
                        />
                      </div>
                    )}
                  />
                  {errors.duration_rate?.message && (
                    <ErrorMessage text={errors.duration_rate.message} />
                  )}
                </div>

                <div className="col-md-4">
                  <div className="row-primary">
                    <h2>Session Total</h2>
                  </div>
                  <Controller
                    name="session_total"
                    control={control}
                    render={({ field }) => (
                      <div className="input-image">
                        <input
                          type="number"
                          placeholder="Session Total"
                          {...field}
                          readOnly
                        />
                      </div>
                    )}
                  />
                </div>
              </div>

              <div className="row d-flex justify-content-between mb-3">
                <div className="col-md-4"></div>
                <div className="col-md-4"></div>

                <div className="col-md-4">
                  <div className="row-primary">
                    <h2>Subtotal</h2>
                  </div>
                  <Controller
                    name="sub_total"
                    control={control}
                    render={({ field }) => (
                      <div className="input-image">
                        <input
                          type="number"
                          placeholder="Subtotal"
                          {...field}
                          readOnly
                        />
                      </div>
                    )}
                  />
                </div>
              </div>

              <div className="row d-flex justify-content-between mb-3">
                <div className="col-md-4"></div>
                <div className="col-md-4"></div>

                <div className="col-md-4">
                  <div className="row-primary">
                    <h2>% Discount</h2>
                  </div>
                  <Controller
                    name="discount"
                    control={control}
                    defaultValue={0}
                    rules={{
                      min: { value: 0, message: "Min 0%" },
                      max: { value: 100, message: "Max 100%" },
                      pattern: {
                        value: /^([0-9]{1,2}|100)$/,
                        message: "Must be between 0 and 100",
                      },
                    }}
                    render={({ field }) => (
                      <div className="input-image">
                        <input
                          type="number"
                          placeholder="Discount %"
                          {...field}
                          disabled={isReadOnly}
                        />
                      </div>
                    )}
                  />
                  {errors.discount?.message && (
                    <ErrorMessage text={errors.discount.message} />
                  )}
                </div>
              </div>

              <div className="row d-flex justify-content-between mb-3">
                <div className="col-md-4"></div>
                <div className="col-md-4"></div>

                <div className="col-md-4">
                  <div className="row-primary">
                    <h2 className='mt-0'>Total</h2>
                  </div>
                  <Controller
                    name="appointment_total"
                    control={control}
                    render={({ field }) => (
                      <div className="input-image">
                        <input
                          type="number"
                          placeholder="Total"
                          {...field}
                          readOnly
                        />
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

//#endregion

//#region LANGUAGE STEP
const LanguageStep = ({ control, setValue, errors, dispatch, item, setConfirmData, clientData, watch, languageState, setLanguageState, facilityState, setFacilityState, departmentState, setDepartmentState }) => {

  const { types: clients } = useSelector(typesSelector);
  useEffect(() => {
    if (clientData?.clientId) {
      dispatch(fetchTypes(1, { search: clientData.clientId }, true, false))
    }
  }, [clientData?.clientId])

  // #region Language dropdown
  // useEffect(() => {
  //   if (item?.language) {
  //     setLanguageState({
  //       label: item?.language?.name || "",
  //       value: item?.language?.id || ""
  //     })
  //   } else {
  //     // setLanguageState([]);
  //   }
  // }, [item?.language])

  // const filteredLanguagesLoadOptions = async (inputValue, loadedOptions, { page }) => {
  //   const result = await dispatch(fetchLanguages(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
  //   return {
  //     options: result.data.map(language => ({
  //       value: language.id,
  //       label: language.name,
  //     })),
  //     hasMore: page !== result?.last_page,
  //     additional: {
  //       page: page + 1,
  //     },
  //   };
  // };
  //#endregion
  const selectedClient = React.useMemo(() => clients?.filter(i => i.id === clientData?.clientId)[0], [clientData, clients]);
  // #region facility dropdown 
  const filteredFacilities = React.useMemo(() => {
    return selectedClient?.facilities?.map(item => ({
      label: item?.facility_name || item?.abbreviation,
      value: item?.id,
    })) || [];
  }, [selectedClient]);

  const formatFacilityAddress = (facilityInfo) => {
    if (!facilityInfo) return '';
    // return `${facilityInfo?.street_address || facilityInfo?.address || ''}, ${facilityInfo?.state?.name || ''}, ${facilityInfo?.city_name || ''}, ${facilityInfo?.zipcode || ''}`;
    return `${facilityInfo?.street_address? facilityInfo?.street_address+ ', ' : '' || facilityInfo?.address? facilityInfo?.address+ ', ' : ''}${facilityInfo?.state?.name? facilityInfo?.state?.name+ ', ' : ''}${facilityInfo?.city_name? facilityInfo?.city_name+ ', ' : ''}${facilityInfo?.zipcode? facilityInfo?.zipcode : ''}`;
  };

  const prevFacilityIdRef = useRef(watch("facility_id"));
  useEffect(() => {
    const facilityId = watch("facility_id");
    if (facilityId !== prevFacilityIdRef.current) {
      const addressData = selectedClient?.facilities?.find(item => item.id === facilityId) || null;
      setValue("address", formatFacilityAddress(addressData));
      prevFacilityIdRef.current = facilityId;
    }
  }, [watch("facility_id"), selectedClient, setValue]);


  // useEffect(() => {
  //   if (item?.facility) {
  //     setFacilityState({
  //       label: item?.facility?.abbreviation || "",
  //       value: item?.facility?.id || ""
  //     })
  //   } else {
  //     setFacilityState([]);
  //   }
  // }, [item?.facility])
  //#endregion

  // #region Department dropdown
  const filteredDepartments = React.useMemo(() =>
    selectedClient?.departments?.map(item => {
      const object = {
        label: item?.name,
        value: item?.id,
      }
      return object
    }), [selectedClient]);

  // useEffect(() => {
  //   if (item?.department) {
  //     setDepartmentState({
  //       label: item?.department?.name || "",
  //       value: item?.department?.id || ""
  //     })
  //   } else {
  //     setDepartmentState([]);
  //   }
  // }, [item?.department])
  //#endregion

  const [selectedFacility, setSelectedFacility] = useState({});
  const [selectedDepartment, setSelectedDepartment] = useState({});

  useEffect(() => {
    setConfirmData((prevData) => ({ ...prevData, Facility: selectedFacility?.label }))
  }, [selectedFacility])
  useEffect(() => {
    setConfirmData((prevData) => ({ ...prevData, Department: selectedDepartment?.label }))
  }, [selectedDepartment])



  return (
    <>
      <div className='step_cards step_4'>
        <h2>Facility / Department</h2>

        {/* <div className="row-primary">
          <h2>Language *</h2>
          <Controller
            name="language_id"
            control={control}
            rules={{
              required: "Please select a language"
            }}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <AsyncPaginate
                  menuPlacement='auto'
                  styles={{
                    ...selectCustomStyles,
                  }}
                  value={languageState}
                  loadOptions={filteredLanguagesLoadOptions}
                  isClearable
                  escapeClearsValue
                  onChange={(obj) => {
                    setLanguageState(obj)
                    setConfirmData((prevData) => ({ ...prevData, Language: obj?.label }))
                    field.onChange(obj?.value);
                  }}
                  additional={{
                    page: 1,
                  }}
                />
                {
                  errors?.language_id?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.language_id?.message} />
                  </div>
                }
              </div>
            }
          />
        </div> */}

        <div className="row-primary">
          <h2>{`Facility`}</h2>

          <Controller
            name="facility_id"
            control={control}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <Select
                  onStateChanges={setSelectedFacility}
                  name="facility_id"
                  options={filteredFacilities || []}
                  {...field}
                  value={field.value
                    ? filteredFacilities?.find((opt) => opt.value === field.value)
                      || (facilityState?.value === field.value ? facilityState : null)
                    : null}
                />
              </div>
            }
          />
        </div>

        {watch("type") == "In Person" && (
          <div className="row-primary">
            <h2>{`Address ${!watch("facility_id") ? "*" : ""}`}</h2>

            <div style={{ width: "100%" }}>
              <Controller
                name="address"
                control={control}
                disabled={watch("facility_id")}
                render={({ field }) =>
                  <input
                    type="text"
                    name='address'
                    className="input-in type_inp"
                    placeholder=''
                    {...field}
                  />
                }
              />

              {errors?.address?.message &&
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.address?.message} />
                </div>
              }
            </div>
          </div>
        )
        }

        <div className="row-primary">
          <h2>Department</h2>
          <Controller
            name="department_id"
            control={control}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <div className="row-primary" >
                  <Select
                    onStateChanges={setSelectedDepartment}
                    name="department_id"
                    options={filteredDepartments || []}
                    {...field}
                    value={field.value
                      ? filteredDepartments?.find((opt) => opt.value === field.value)
                        || (departmentState?.value === field.value ? departmentState : null)
                      : null}
                  />
                  {(watch("type") == "In Person") &&
                    <Controller
                      name="department_text"
                      control={control}
                      render={({ field }) =>
                        <input
                          type="text"
                          name='department_text'
                          className="input-in type_inp"
                          placeholder=''
                          {...field}
                        />
                      }
                    />
                  }
                </div>
                {errors?.department_id?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.department_id?.message} />
                  </div>
                }
              </div>
            }
          />
        </div>
      </div>
    </>
  )
}
//#endregion

//#region  FILTERS
const FilterStep = ({ control, fields, setFields, isEditMode }) => {

  const handleChangeRadios = (value, onChange, field) => {
    onChange(value == 1 ? 0 : 1);
  };

  return (
    <>
      <div className='step_cards filters step_4'>
        <h2>Filters</h2>
        <div className='w-100'>
          {fields.map((val) => (
            <div className={`row-primary align-items-center ${val.isLocked && 'lock_row'}`}>
              <h2 className="col-6 mt-0">{val.label}</h2>
              <Controller
                name={val.name}
                control={control}
                render={({ field }) => (
                  <div className="switch_row">
                    <Switch
                      className={val?.isLocked && "lockSwitch"}
                      checked={field.value === 1}
                      onChange={() => handleChangeRadios(field.value ? 1 : 0, field.onChange, field)}
                      color="primary"
                      disabled={isEditMode}
                    />
                  </div>
                )}
              />
              {val?.isLocked ?
                <h2 className='mt-0 fst-italic'>locked</h2>
                : <></>
              }
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
//#endregion

//#region REQUESTER DATA
const UserDataStep = ({
  control,
  errors,
  isEditMode
}) => {

  return (
    <>
      <div className='step_cards step_5'>
        <h2>Required Data</h2>
        <div className='w-100'>
          <div className="row-primary">
            <h2>Requester Full Name</h2>
            <div className='w-100'>
              <Controller
                name="requester_name"
                control={control}
                render={({ field }) => <input className="input-in type_inp" type="text" name='requester_name' placeholder='Requester Full Name' {...field} />}
              />
              {
                errors?.requester_name?.message &&
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.requester_name?.message} />
                </div>
              }
            </div>
          </div>

          <div className="row-primary">
            <h2>Requester Email</h2>
            <div className="w-100">
              <Controller
                name="requester_email"
                rules={{
                  validate: (value) => {
                    if (!value) return true;
                    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
                    const emails = value.split(',').map(email => email.trim()).filter(Boolean);
                    for (let email of emails) {
                      if (!emailRegex.test(email)) {
                        return "Please enter valid email address(es)";
                      }
                    }
                    return true;
                  }
                }}
                control={control}
                render={({ field }) => <input className="input-in type_inp" type="text" name='requester_email' placeholder='Requester email (comma separated)' {...field} />}
              />
              {
                errors?.requester_email?.message &&
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.requester_email?.message} />
                </div>
              }
            </div>
          </div>

          <div className="row-primary">
            <h2>Caller Phone Number</h2>
            <div className="w-100">
              <Controller
                name="caller_phone"
                control={control}
                render={({ field }) => <PhoneInput className="input-in type_inp" type="tel" name='caller_phone' placeholder='Caller Phone number' {...field} />}
              />
              {
                errors?.caller_phone?.message &&
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.caller_phone?.message} />
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
//#endregion

// #region DYNAMIC FIELDS
const DynamicStep = ({ control, errors, watch, dynamicFields, values, setValues, isEditMode }) => {
  return (
    <div className='step_cards step_5'>
      {/* <h2>Required Data</h2> */}
      <h2>Dynamic Fields</h2>
      <div className='w-100'>
        {values?.length > 0 &&
          values?.map((f, index) => (
            f?.name && (
              <div key={index} className='w-100'>
                <div className="row-primary">
                  <h2>{f.name} {f?.required ? "*" : ""}</h2>
                  <Controller
                    name={`dynamic_fields.${index}.value`}
                    control={control}
                    defaultValue={f.value || ""}
                    rules={f?.required ? {
                      required: `Please enter ${f.name}`
                    } : {}}
                    render={({ field }) => (
                      <div className='w-100'>
                        <input
                          className="input-in type_inp"
                          type="text"
                          required={f?.required}
                          {...field}
                          disabled={isEditMode && !['facility_id', 'address', 'department_id', 'department_text', 'requester_name', 'requester_email', 'caller_phone'].includes(f?.name)}
                          onChange={(e) => {
                            field.onChange(e.target.value);
                            const updatedValues = [...values];
                            updatedValues[index] = {
                              ...updatedValues[index],
                              value: e.target.value,
                            };
                            setValues(updatedValues);
                          }}
                        />
                        {
                          errors?.dynamic_fields?.[index]?.value?.message &&
                          <div style={{ marginBottom: 10 }}>
                            <ErrorMessage text={errors?.dynamic_fields?.[index]?.value?.message} />
                          </div>
                        }
                      </div>
                    )}
                  />
                </div>
              </div>
            )
          ))}
      </div>
    </div>
  )
}
//#endregion

//#region GenderStep
const GenderNoteStep = ({
  control,
  isEditMode
}) => {

  return (
    <>
      <div className='step_cards step_5'>
        {/* <h2>Required Data</h2> */}
        <div className='w-100'>

          <div className="row-primary">
            <h2>Vendor Gender</h2>
            <Controller
              name="gender"
              control={control}
              render={({ field }) =>
                <div style={{ width: "100%" }}>
                  <Select
                    name="gender"
                    options={genderOptions || []}
                    {...field}
                    value={field.value ? genderOptions?.find((opt) => field.value == opt.value) : ""}
                    isDisabled={isEditMode}
                  />
                </div>
              }
            />
          </div>


          <div className="row-primary">
            <h2>Notes</h2>
            <Controller
              name="notes"
              control={control}
              render={({ field }) => <textarea className="input-in type_inp" name='notes' placeholder='Enter some notes' disabled={isEditMode} {...field} />}
            />
          </div>

        </div>
      </div>
    </>
  )
}
//#endregion

const NotesStep = ({
  control,
  isEditMode
}) => {

  return (
    <>
      <div className='step_cards step_5'>
        <h2>Notes</h2>
        <div className='w-100'>
          <div className="row-primary">
            <h2>Notes <small>(Optional)</small></h2>
            <Controller
              name="admin_notes"
              control={control}
              render={({ field }) => <textarea className="input-in type_inp" name='admin_notes' placeholder='Enter some notes' disabled={isEditMode} {...field} />}
            />
          </div>
        </div>
      </div>
    </>
  )
}


//#region APPOINTMENT FORM 
const AddAppointmentForm = ({ item, handleClose, callback, show, popupType, onUpdateSuccess }) => {
  //#region INITIALIZATION / STATES / VARIABLES
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [card5Values, setCard5Values] = useState([]);  //this is an array of values
  const method = useForm({
    defaultValues: {
      custom_pricing: 0,
      discount: 0,
      account_id: "",
      sub_account_id: "",
      date: moment().format('YYYY-MM-DD'),
      language_id: "",
      language_text: "",
      facility_id: "",
      department_id: "",
      gender: "",
      notes: "",
      admin_notes: "",
      caller_phone: "",
      requester_name: "",
      dynamic_fields: [],
      type: item?.id ? item?.type : DEFAULT_APPOINTMENT_TYPE,
      auto_assign: 0,
      timezone_id: '',
      video_platform: "algovi",
      exclude_interpreter: false
    }
  });
  const { register, handleSubmit, watch, formState: { errors }, control, setValue, getValues, setError: setErrors } = method;
  const { error, loader } = useSelector(hospitalSelector);
  const { state: states } = useSelector(stateSelector);
  const { city: cities } = useSelector(citySelector);
  const { types: accounts } = useSelector(typesSelector);
  const { dynamicFields } = useSelector(typesSelector);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [ConfirmData, setConfirmData] = useState({
    clientName: '',
    clientId: '',
    timezone: '',
    subClientName: '',
    subClientId: '',
    Language: '',
    Facility: '',
    Department: '',
  });

  const isEditRequestMode = popupType === "edit-request";
  const isEditMode = !!item?.id && !["copy", "from-request", "edit-request"].includes(popupType);
  const isClientPortal = popupType === "client-portal";
  const isAccountLocked = popupType === "from-request";


  //#region States for accounts

  const [mainAccount, setMainAccount] = useState({
    label: "",
    value: ""
  });

  const [subClient, setSubclient] = useState({});
  const [allSubAccounts, setAllSubAccounts] = useState([]);
  const [subAccountLoading, setSubAccountLoading] = useState(false);

  const { types: mainClients } = useSelector(typesSelector);
  const { accounts: subClients } = useSelector(accountsSelector);
  // const dynamicFields = useMemo(() => !watch('sub_account_id') ? dynamicFieldsMainAccount : dynamicFieldsSubAccount, [watch('sub_account_id')]);
  //#endregion


  //#region LANGUAGE
  // const [languageState, setLanguageState] = useState({
  //   label: "",
  //   value: ""
  // });

  const [languageState, setLanguageState] = useState(
    item?.language
      ? { label: item.language.name || "", value: item.language.id || "" }
      : { label: "", value: "" }
  );
  const [timezoneState, setTimezoneState] = useState({
    label: "",
    value: ""
  });
  //#endregion

  //#region Facility

  // set language in step 3
  useEffect(() => {
    if (item?.language?.id) {
      setLanguageState({
        label: item.language.name || "",
        value: item.language.id || ""
      });
    } else {
      setLanguageState({ label: "", value: "" });
    }
  }, [item?.language?.id]);

  const [facilityState, setFacilityState] = useState({
    label: "",
    value: ""
  })

  //#endregion

  //#region Department

  const [departmentState, setDepartmentState] = useState({
    label: "",
    value: ""
  })

  //#endregion


  //#region FILTERS
  const [fields, setFields] = useState(
    [
      { label: "US Based Vendor", name: "us_based", isLocked: 0 },
      { label: "Non US Based Vendor", name: "non_us_based", isLocked: 0 },
      { label: "English To Target Language", name: "english_to_target", isLocked: 0 },
      { label: "Spanish To Target Language", name: "spanish_to_target", isLocked: 0 },
      { label: "Court Certified", name: "court_certified", isLocked: 0 },
      { label: "Medical Certified", name: "medical_certified", isLocked: 0 },
    ]
  );


  //#endregion


  //#endregion


  //#region RESET DATA
  const resetAllFields = () => {

    dispatch(setError({}))
    setValue("type", DEFAULT_APPOINTMENT_TYPE);

    setValue("date", moment().format('YYYY-MM-DD'))

    setValue('requester_name', '');
    setValue('requester_email', '');
    setValue('caller_phone', '');
    setValue('gender', '');

    setValue('account_id', '');
    setValue('language_id', '');
    setValue('sub_account_id', '');
    setValue('name', '');
    setValue('status', 1)
    setValue("city_id", '')
    setValue("state_id", '')
    setValue("dynamic_fields", []);
    setValue("auto_assign", 0)
    setValue("timezone_id", '')
    setCurrentIndex(0);

    setMainAccount({
      label: "",
      value: ""
    })
    setSubclient({
      label: "",
      value: ""
    })
    setLanguageState({
      label: "",
      value: ""
    })
    setFacilityState({
      label: "",
      value: ""
    })
    setDepartmentState({
      label: "",
      value: ""
    })
    setFields([
      { label: "US Based Vendor", name: "us_based", isLocked: 0 },
      { label: "Non US Based Vendor", name: "non_us_based", isLocked: 0 },
      { label: "English To Target Language", name: "english_to_target", isLocked: 0 },
      { label: "Spanish To Target Language", name: "spanish_to_target", isLocked: 0 },
      { label: "Court Certified", name: "court_certified", isLocked: 0 },
      { label: "Medical Certified", name: "medical_certified", isLocked: 0 },
    ])




    //#region Language facility reset fields

    setValue("department_id", '');
    setValue("department_text", '');
    setValue('language_id', '');
    setValue('facility_id', '');
    setValue('address', '');

    setValue('start_time', moment(new Date, ["h:mm A"]).format("HH:mm"));
    setValue('end_time', moment(new Date, ["h:mm A"]).add(15, "minutes").format("HH:mm"));
    setValue('estimated_duration', 0);
    setValue('_rate_signature', '');

    //#endregion
  };
  //#endregion

  //#region USEEFFECTS

  const fetchSubClient = async () => {
    const result = await Api.fetchTypes(1, { search: watch("account_id") });
    if (result?.status == 200) {
      return await result?.data?.data?.data
    }
    else {
      console.log("Error fetching client")
      return null
    }
  }

  useEffect(() => {
    if (watch('account_id')) {
      const account_id = watch("account_id");
      account_id ? dispatch(fetchMainClients(account_id, true, true)) : dispatch(setDynamicFields([]))
      // async function fetchClient() {
      //   const result = await fetchSubClient()
      //   if (result?.length > 0) {
      //     setAllSubAccounts(result[0]?.sub_accounts)
      //   }

      // }
      // fetchClient()

    }
  }, [watch("account_id")])



  useEffect(() => {
    if (show) {
      setCurrentIndex(0);
    }
    return () => {
      setCurrentIndex(0);
    };
  }, [show]);

  useEffect(() => {
    if (!show || !isClientPortal || !item?.account_id || item?.id) return;

    let active = true;

    const populatePortalClient = async () => {
      setSubAccountLoading(true);
      setValue("account_id", item.account_id);
      setMainAccount({
        label: item.account_name || item.client_label || item.name || "",
        value: item.account_id,
      });

      try {
        const result = await Api.fetchTypes(1, { id: item.account_id });
        const fetchedClient = result?.data?.data?.data?.[0];

        if (!active) return;

        const fetchedSubAccounts = fetchedClient?.sub_accounts ?? item.sub_accounts ?? [];
        const timezoneObj = fetchedClient?.timezone ?? null;
        const newTimezone = timezoneObj ? { value: timezoneObj.id, label: timezoneObj.display_name } : null;

        setAllSubAccounts(fetchedSubAccounts);
        setMainAccount({
          label: item.account_name || item.client_label || item.name || "",
          value: item.account_id,
          data: fetchedClient || null,
        });
        setConfirmData((prevData) => ({
          ...prevData,
          clientName: item.account_name || item.client_label || prevData.clientName,
          clientId: item.account_id,
          timezone: newTimezone,
        }));
      } catch (error) {
        if (!active) return;

        setAllSubAccounts(item.sub_accounts ?? []);
        setConfirmData((prevData) => ({
          ...prevData,
          clientName: item.account_name || item.client_label || prevData.clientName,
          clientId: item.account_id,
        }));
      } finally {
        if (active) {
          setSubAccountLoading(false);
        }
      }
    };

    populatePortalClient();

    return () => {
      active = false;
    };
  }, [show, isClientPortal, item?.account_id, item?.account_name, item?.client_label, item?.id, item?.sub_accounts, setValue, setConfirmData]);
  useEffect(() => {

    // dispatch(fetchTypes(1, { pageLength: 10, sortBy: "id", sortDirection: "asc" }));
    // dispatch(fetchCitys(1, { pageLength: 10, sortBy: "id", sortDirection: "asc" }));
    // dispatch(fetchStates(1, { pageLength: 10, sortBy: "id", sortDirection: "asc" }))

    return () => resetAllFields()
  }, [show])


  useEffect(() => {

    if (show && item?.id) {
      console.log("error", item)
      setValue('account_id', item?.account_id || '');
      if (item?.accounts) {
        setMainAccount({
          label: item?.accounts?.user?.name || "",
          value: item?.accounts?.id || "",
          data: item?.accounts
        })
      }
      if (item?.subclient) {
        setSubclient({
          label: item?.subclient?.subaccount_name || "",
          value: item?.subclient?.id || ""
        })
      }
      setValue('sub_account_id', item?.subclient_id || '');
      // setValue('type', item?.type || '');
      setValue('type', item?.type || DEFAULT_APPOINTMENT_TYPE);
      setValue('name', item?.name || '');
      setValue('date', moment(item?.date).format('YYYY-MM-DD'))
      setValue('department_id', item?.appointment_details?.department?.id || '')
      setValue('department_text', item?.appointment_details?.department_text || '');
      setValue('language_id', item?.language_id || '');
      setValue('facility_id', item?.appointment_details?.facility?.id || '');
      const facilityInfo = item?.appointment_details?.facility;
      // const formattedAddress = facilityInfo
      //   ? `${facilityInfo?.street_address || facilityInfo?.address || ''}, ${facilityInfo?.state?.name || ''}, ${facilityInfo?.city_name || ''}, ${facilityInfo?.zipcode || ''}`
      //   : item?.appointment_details?.address || '';
      const formattedAddress = facilityInfo
          ? [facilityInfo?.street_address, facilityInfo?.state?.name,facilityInfo?.city_name, facilityInfo?.zipcode, ].filter(Boolean).join(', ')
          : item?.appointment_details?.address || '';
      setValue('address', formattedAddress);
      setValue('requester_name', item.appointment_details?.requester_name || '');
      setValue('requester_email', item.appointment_details?.requester_email || '');
      setValue('caller_phone', item.appointment_details?.requester_phone || '');

      if (item?.appointment_details?.facility?.id) {
        setFacilityState({
          label: item.appointment_details.facility.abbreviation || item.appointment_details.facility.facility_name || "",
          value: item.appointment_details.facility.id,
        });
      }
      if (item?.appointment_details?.department?.id) {
        setDepartmentState({
          label: item.appointment_details.department.department_name || "",
          value: item.appointment_details.department.id,
        });
      }
      setConfirmData((prevData) => ({
        ...prevData,
        Facility: item?.appointment_details?.facility?.abbreviation || item?.appointment_details?.facility?.facility_name || "",
        Department: item?.appointment_details?.department?.department_name || "",
      }));

      setValue('gender', item?.appointment_details?.interpreter_gender || '');
      setValue('notes', item?.appointment_details?.notes || '');

      setValue('start_time', item?.start_time || '');
      setValue('end_time', item?.end_time || '');
      setValue('estimated_duration_unit', item?.estimated_duration_unit || (item?.type === 'In Person' ? 'hour' : 'minute'));
      setValue('estimated_duration', item?.estimated_duration || '');
      setValue('timezone_id', item?.timezone_id || '');

      // setValue('estimated_duration', item?.estimated_duration || '');

      if (item?.type !== "Telephonic" && item?.appointment_custom_pricing) {
        setValue('custom_pricing', item?.appointment_details?.custom_pricing);
        setValue('mileage', item?.appointment_custom_pricing?.mileage || '');
        setValue('mileage_rate', item?.appointment_custom_pricing?.mileage_rate || '');
        setValue('mileage_total', item?.appointment_custom_pricing.mileage_total || '');
        setValue('travel_hours', item?.appointment_custom_pricing.travel_hours || '');
        setValue('travel_rate', item?.appointment_custom_pricing.travel_rate || '');
        setValue('travel_total', item?.appointment_custom_pricing.travel_total || '');
        setValue('duration_rate', item?.appointment_custom_pricing.duration_rate || '');
        setValue('min_duration', item?.appointment_custom_pricing.min_duration || '');
        setValue('session_total', item?.appointment_custom_pricing.session_total || '');
        setValue('discount', item?.appointment_custom_pricing.discount || 0);
        setValue('sub_total', item?.appointment_custom_pricing.sub_total || '');
        setValue('appointment_total', item?.appointment_custom_pricing.appointment_total || '');

      }

      // console.log('adasds',JSON.parse(item?.appointment_details?.dynamic_fields));

      setValue('status', (typeof (item?.status) == "number") ? item?.status : 1)

      // Initialize video platform and link for Video Remote Interpretation appointments
      if (item?.type === "Video Remote Interpretation") {
        setValue('video_platform', item?.appointment_details?.video_platform || 'algovi');
        setValue('video_link', item?.appointment_details?.video_link || '');
      }

      // Initialize exclude_interpreter
      setValue('exclude_interpreter', item?.exclude_interpreter || false);

      dispatch(setError({}))
    }
    return () => resetAllFields()

  }, [item, show])

  useEffect(() => {

    if (states?.length > 0) {
      if (item?.state_id)
        setValue("state_id", item?.state_id)
    }
    if (item?.city_id) setValue("city_id", item?.city_id)
  }, [item, cities, states]);

  useEffect(() => {
    if (!item?.appointment_details?.dynamic_fields) {

      setCard5Values(
        dynamicFields?.length > 0 && dynamicFields?.map(f => ({ name: f?.name, value: "", required: f?.required == 1 ? true : false, show_in_invoice: (f?.show_in_invoice == 1 || f?.show_in_invoice === true) ? true : false, }))
      )
    } else {
      const dynamic_fields = item?.appointment_details?.dynamic_fields ? JSON.parse(item?.appointment_details?.dynamic_fields) : []
      setCard5Values(dynamic_fields?.map(f => ({ name: f?.name, value: f?.value, required: f?.required == 1 ? true : false, show_in_invoice: (f?.show_in_invoice == 1 || f?.show_in_invoice === true) ? true : false })))
    }
  }, [dynamicFields, item?.appointment_details?.dynamic_fields])


  useEffect(() => {
    if (card5Values?.length > 0) {
      setValue("dynamic_fields", card5Values)
    }
  }, [card5Values])

  const lastAccountRef = useRef(null);
  useEffect(() => {
    if (item?.account_id) {
      if (lastAccountRef.current !== item?.account_id) {
        lastAccountRef.current = item?.account_id;
        dispatch(fetchTypes(1, { search: item?.accounts?.name }, true, false));
      }
      setValue("account_id", item?.account_id);

      if (item?.accounts?.sub_accounts?.length > 0) {
        setAllSubAccounts(item.accounts.sub_accounts);
      }
    } else {
      lastAccountRef.current = null;
    }

    if (item?.subclient_id) {
      setValue("sub_account_id", item?.subclient_id)
    }

  }, [item?.account_id, item?.subclient_id]);


  useEffect(() => {
    setConfirmData({
      clientName: item?.accounts?.user?.name || '',
      clientId: item?.accounts?.id || '',
      // timezone: item?.timezone || '',
      timezone: item?.appointment_details?.timezone || '',
      subClientName: item?.subclient?.subaccount_name || '',
      subClientId: item?.subclient?.id || '',
      Language: item?.language?.name || '',
      Facility: item?.facility?.abbreviation || '',
      Department: item?.department?.name || '',
    })
  }, [item]);


  useEffect(() => {
    fields?.forEach(field => {
      setValue(field.name, 0)
    })

  }, [])


  useEffect(() => {
    let active = true;

    const fetchClient = async () => {
      const result = await Api.fetchTypes(1, { id: watch("account_id") });
      if (active && result?.status === 200) {
        return result?.data?.data?.data;
      } else {
        console.log("Error fetching client");
        return null;
      }
    };

    async function filterClientWork() {
      const accountId = watch("account_id");
      if (accountId) {
        let client = await fetchClient();
        if (active && client?.length > 0) {
          client = client[0];
          if (client?.filters) {
            setFields(fields =>
              fields?.map(field => {
                if (!field) return { ...field, isLocked: false };

                if (typeof client.filters[field.name] === "number") {
                  const object = {
                    ...field,
                    isLocked: client.filters?.[`${field.name}_locked`] ?? false,
                  };

                  const preferredValue = item?.id
                    ? item?.appointment_details?.[field.name]
                    : client.filters?.[field.name];

                  if (typeof preferredValue === "number") {
                    setValue(field.name, preferredValue);
                  }

                  return object;
                } else {
                  return field;
                }
              })
            );
          }
        }
      }
    }

    if (watch("account_id")) {
      filterClientWork();
    }

    return () => {
      active = false;
    };
  }, [watch("account_id")]);


  //#endregion


  //#region FORM SUBMITION
  const submitCallback = (status, message, data) => {
    if (status) {
      if (item?.id && ["edit", "edit-request"].includes(popupType)) {
        toast.success(
          message ||
            (popupType === "edit-request"
              ? 'Appointment request updated successfully.'
              : 'Appointment updated successfully.'),
          {
            className: "successToast",
          }
        );
        handleClose && handleClose();
        if (popupType === "edit") {
          onUpdateSuccess && onUpdateSuccess(data);
        }else if (popupType === "edit-request") {
          callback && callback(data);
        }
        dispatch(fetchAppointments());
        return;
      }

      // toast.success(message, {
      //className:"successToast",
      //})
      resetAllFields()
      handleClose();
      Swal.fire({
        title: "Success!",
        text: message,
        icon: "success"
      }).then(() => {
        if (isEditMode) {
          navigate(`/appointments/view/${data?.id}`);
          callback && callback(data);
        } else if (data.type === 'OPI On Demand') {
          navigate(`/appointments/view/${data?.id}`);
        }  else if (popupType === "client-portal") {
          callback && callback(data);
          navigate(`/user/appointment-requests/view/${data?.id}`);
        } else {
          callback && callback(data)
        }
      })
      dispatch(fetchAppointments());
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {
    dispatch(setError({}))
    const newData = { ...data };
    // Ensure filter fields are always present in payload even if FilterStep is skipped
    fields?.forEach(f => {
      if (newData[f.name] === undefined) newData[f.name] = 0;
    });
    delete newData._rate_signature;

    if (popupType === "from-request" && item?.id) {
      console.log("item.id", item.id);
      newData.appointment_request_id = item.id;
    }

    for (const key in newData) {
      if (Object.prototype.hasOwnProperty.call(newData, key)) {
        const element = newData[key];
        if (element == undefined) {
          delete newData[key];
        }
      }
    }

    // If user selected 'Language not listed', include the typed language text
    if (data.language_id === LANGUAGE_NOT_LISTED_OPTION.value) {
      newData.language_text = data.language_text || '';
    }
    if (popupType === "client-portal") {
      newData.status = "Request";
    }

    //   if (item?.id) {
    //     dispatch(updateAppointment(newData, item?.id, submitCallback));
    //   } else {}
    //       // console.log("newData", newData);
    // dispatch(addAppointment(newData, submitCallback));
    // if (item?.id && popupType !== "copy") {
    if (item?.id && popupType === "edit-request") {
      dispatch(updateRequest(newData, item.id, submitCallback));
    } else if (item?.id && !["copy", "from-request"].includes(popupType)) {
      dispatch(updateAppointment(newData, item.id, submitCallback));
    } else if (popupType === "client-portal") {
      dispatch(addRequest(newData, submitCallback));
    } else {
      dispatch(addAppointment(newData, submitCallback));
    }
  }
  //#endregion


  //#region PREV NEXT HANDLERS
  const requiredFields = [
    "account_id",
    "date"
  ]


  // Next button handler
  const handleNext = () => {
    if (currentIndex < visibleCards.length - 1) {
      handleSubmit(
        // async (data) => {
        (data) => {
          const currentCard = visibleCards[currentIndex];
          const clients = ConfirmData?.subClientId ? subClients : mainClients;

          if (!isClientPortal && currentCard?.id === 6 && dynamicFields?.length == 0) {
            setCurrentIndex(currentIndex + 1);
            return
          }
          if (currentCard?.id === 6 && clients?.length > 0) {
            if (!watch("estimated_duration")) {
              setErrors("estimated_duration", {
                type: "required",
                message: `Please enter a duration`
              })
              return
            }
          }
          if (currentCard?.id === 4 && watch("type") == "In Person") {
            if (!watch("facility_id") && !watch("address")) {
              setErrors("address", {
                type: "required",
                message: `Please enter a address`
              })
              return
            } else {
              setErrors("address", "")
            }
          }

          // For client-portal, ensure selected date/time is at least 24 hours ahead in the selected timezone
          // if (isClientPortal && currentCard?.id === 3) {
          //   const selectedDate = data.date || getValues('date');
          //   const selectedTime = data.start_time || getValues('start_time');
          //   const timezoneId = getValues('timezone_id');

          //   if (!selectedDate || !selectedTime || !timezoneId) {
          //     setErrors('start_time', { type: 'required', message: 'Please select date, time and timezone' });
          //     return;
          //   }

          //   // Try to fetch timezone details (name) to validate using moment-timezone
          //   let tzName;
          //   try {
          //     const tzResult = await dispatch(fetchTimezone(1, { id: timezoneId }, true, true));
          //     // tzResult may be an array or single object
          //     const tzObj = Array.isArray(tzResult) ? tzResult[0] : tzResult;
          //     tzName = tzObj?.name || tzObj?.timezone || null;
          //   } catch (e) {
          //     tzName = null;
          //   }

          //   // Fallback to browser timezone if tzName not available
          //   if (!tzName) tzName = moment.tz.guess();

          //   const combined = `${selectedDate} ${selectedTime}`; // date in YYYY-MM-DD and time in HH:mm
          //   const selectedMoment = moment.tz(combined, 'YYYY-MM-DD HH:mm', tzName);
          //   const nowInTz = moment.tz(tzName);
          //   const diffHours = selectedMoment.diff(nowInTz, 'hours', true);

          //   if (diffHours < 24) {
          //     Swal.fire({
          //       title: 'Interpreter on-demand',
          //       text: 'Please call +1 123123 to be connected with an interpreter on-demand',
          //       icon: 'info',
          //       confirmButtonText: 'OK'
          //     });
          //     return;
          //   }
          // }

          for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
              const element = data[key];
              if (currentCard?.values?.includes(key)) {
                if (!element) {
                  setErrors(key, {
                    type: "required",
                    message: `This field is required`
                  })
                  return
                } else {
                  setErrors(key, null)
                }
              }
            }
          }
          setCurrentIndex(currentIndex + 1);

        },
        (error) => {
          console.log("Validation Errors:", error); // Error callback
        }
      )();
    }
  };

  // Previous button handler
  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };
  //#endregion
  const showDynamicStep = card5Values[0]?.name ? true : false;
  const showListInterpreters = watch("type") == "Video Remote Interpretation" || watch("type") == "OPI On Demand";

  //#region  CARDS INITIALIZATION
  const cards = [
    {
      id: 1,
      content: "Select a Client",
      component: <AccountStep control={control} errors={errors} item={item} dispatch={dispatch} accounts={accounts} setConfirmData={setConfirmData}
        mainAccount={mainAccount} setMainAccount={setMainAccount}
        subClient={subClient} setSubclient={setSubclient}
        setAllSubAccounts={setAllSubAccounts}
        allSubAccounts={allSubAccounts}
        setValue={setValue}
        isEditMode={isEditMode}
        isClientPortal={isClientPortal}
        isAccountLocked={isEditMode || popupType === "from-request" || popupType === "edit-request"}
      />,
      values: ["account_id"]
    },
    {
      id: 2,
      content: "Appointment Type",
      component: <TypeStep control={control} name="type" errors={errors} item={item} dispatch={dispatch} isEditMode={isEditMode} popupType={popupType} allSubAccounts={allSubAccounts} subClient={subClient} setSubclient={setSubclient} subAccountLoading={subAccountLoading} />
    },
    {
      id: 3,
      content: "Date & Time",
      component: <DateTimeStep control={control} watch={watch} errors={errors} item={item}
        dispatch={dispatch}
        setConfirmData={setConfirmData}
        languageState={languageState}
        setLanguageState={setLanguageState}
        timezoneState={timezoneState}
        setTimezoneState={setTimezoneState}
        clientData={ConfirmData}
        popupType={popupType}
        isEditMode={isEditMode} />,
      values: ["date"]
    },
    {
      id: 4,
      content: "Language / Facility / Department",
      component: <LanguageStep control={control} watch={watch} setValue={setValue} errors={errors} item={item} dispatch={dispatch} setConfirmData={setConfirmData}
        clientData={ConfirmData}
        languageState={languageState} setLanguageState={setLanguageState}
        facilityState={facilityState} setFacilityState={setFacilityState}
        departmentState={departmentState} setDepartmentState={setDepartmentState}
        isEditMode={isEditMode}
      />
    },
    {
      id: 5,
      content: "Filters",
      component: <FilterStep control={control} watch={watch} errors={errors} item={item} dispatch={dispatch} setValue={setValue} fields={fields} setFields={setFields} isEditMode={isEditMode} />
    },
    {
      id: 6,
      content: "User Required Data",
      component: <UserDataStep control={control} errors={errors} setValue={setValue} item={item} dispatch={dispatch} isEditMode={isEditMode} />,
      // values: ["requester_name", "requester_email", "caller_phone"]
    },



    ...(showDynamicStep ? [{
      id: 7,
      content: "Required Data",
      component: <DynamicStep control={control} watch={watch} errors={errors} setValue={setValue} dynamicFields={dynamicFields} values={card5Values} setValues={setCard5Values} item={item} dispatch={dispatch} isEditMode={isEditMode} />
    }] : []),

    // {
    //   id: 8,
    //   content: "Required Data",
    //   component: <GenderNoteStep control={control} errors={errors} setValue={setValue} item={item} dispatch={dispatch} isEditMode={isEditMode} />
    // },
    ...(showListInterpreters ? [{
      id: 9,
      content: "List Interpreters",
      component: <ListInterpreters control={control} handleSubmit={handleSubmit(onSubmit)} item={item} watch={watch} dispatch={dispatch} onClose={handleClose} ConfirmData={ConfirmData} popupType={popupType} language_id={watch("language_id")} isEditMode={isEditMode} />
    }] : []),

    {
      id: 8,
      content: "Notes",
      component: <NotesStep control={control} errors={errors} setValue={setValue} item={item} dispatch={dispatch} isEditMode={isEditMode} />
    },
    {
      id: 10,
      content: "Confirm Data",
      component: <ConfirmDataStep control={control} handleSubmit={handleSubmit(onSubmit)} item={item} watch={watch} dispatch={dispatch} onClose={handleClose} ConfirmData={ConfirmData} popupType={popupType} isEditMode={isEditMode} />
    },
  ];
  //#endregion



  // const isEditRequestMode = popupType === "edit-request";
  const visibleCards = (isClientPortal || isEditRequestMode)
    ? cards.filter((card) => [2, 3, 4, 6, 10].includes(card.id))
    : cards;

  return (
    <div>
      <FormProvider
        {...method}
      >
        <form >

          {visibleCards[currentIndex].component}


        </form>
      </FormProvider>
      <div className='row_shift Step_change'>
        {currentIndex > 0 && (
          <button type='button' onClick={handlePrev} className='main_button'>
            <img src="/images/arrow-right.png" alt />
          </button>
        )}

        {currentIndex < visibleCards.length - 1 && (
          <button type='button' onClick={handleNext} className='main_button'>
            <img src="/images/arrow-left.png" alt="" style={{ filter: 'grayscale(1) brightness(5)' }} />
          </button>
        )}

        {currentIndex == visibleCards.length - 1 && !isEditMode &&
          <button type="button" className="main_button" onClick={resetAllFields}>

            {loader ?
              <>
                <Spinner size="sm">
                  Loading...
                </Spinner>

                <span>
                  {' '}Loading
                </span>
              </>
              :
              <span>
                {/* {item?.id ? "Update" : "Create"} */}
                Start Over
              </span>
            }
          </button>
        }
      </div>
    </div>
  )
}
//#endregion

//#region APPOINTMENT MAIN
const AddAppointment = ({ item, onClose, callback, show, popupType }) => {
  const closeModalRef = useRef();
  const navigate = useNavigate();
  const [apptData, setApptData] = useState({});
  const [secondModal, setSecondModal] = useState(false);
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [emailPreviewHtml, setEmailPreviewHtml] = useState('');
  const [emailPreviewSubject, setEmailPreviewSubject] = useState('');
  const [emailPreviewButtonText, setEmailPreviewButtonText] = useState('');
  const [emailPreviewRedirectLink, setEmailPreviewRedirectLink] = useState('');


  const handleCloseSecondModal = (data) => {
    setSecondModal(false);
  }

  const handleOpenSecondModal = (data) => {
    setApptData(data);
    setSecondModal(true);
  }

  const handleOpenEmailModal = (data) => {
    setApptData(data);
    setEmailPreviewHtml(data?.standard_email_html || '');
    setEmailPreviewSubject(data?.standard_email_subject || 'Appointment Updated');
    setEmailPreviewButtonText(data?.standard_email_button_text || 'View Appointment');
    setEmailPreviewRedirectLink(data?.standard_email_redirect_link || '');
    setEmailModalOpen(true);
  };

  const handleCloseEmailModal = () => {
    setEmailModalOpen(false);
  };

  const handleEmailModalComplete = () => {
    setEmailModalOpen(false);
    onClose && onClose();
    callback && callback(apptData);
    if (item?.id) {
      navigate(`/appointments/view/${apptData?.id}`);
    }
  };


  return (
    <React.Fragment>
      <AfterAppointmentModal
        item={apptData}
        show={secondModal}
        handleClose={handleCloseSecondModal}
      />

      <UpdateEmailConfirmationModal
        show={emailModalOpen}
        handleClose={handleCloseEmailModal}
        appointmentId={apptData?.id}
        standardHtml={emailPreviewHtml}
        onComplete={handleEmailModalComplete}
      />

      <BootstrapDialog
        fullWidth={true}
        maxWidth={"md"}
        onClose={(e, reason) => {
          if (reason != "backdropClick") onClose();
        }}
        aria-labelledby="customized-dialog-title"
        open={show}
        sx={{
          "& .MuiDialog-container": {
            alignItems: "flex-start",
          },
          "& .MuiPaper-root": {
            overflowY: "visible",
            margin: "auto",
          },
        }}
      >
        <div className="modal-content full_modal">
          <DialogTitle>
            <div className="modal-header header_modal align-items-center">
              <div></div>
              {/* <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Appointment</h5> */}

              {/* <h5 className="modal-title_u">
                {item?.id
                  ? popupType === "copy"
                    ? "Copy Appointment"
                    : "Update Appointment"
                  : "Add Appointment"}
              </h5> */}
              <h5 className="modal-title_u">
                {item?.id
                  ? popupType === "copy"
                    ? "Copy Appointment"
                    : popupType === "from-request"
                      ? "Add Appointment"
                    : "Update Appointment"
                  : popupType === "client-portal"
                    ? "Create Appointment Request"
                  : "Add Appointment"}
              </h5>

              <button
                onClick={onClose}
                type="button"
                className="btn-close"
                aria-label="Close"
              ></button>
            </div>
          </DialogTitle>
          <div className="modal-body modal_form_body">
            <AddAppointmentForm
              item={item}
              handleClose={() => {
                onClose && onClose();
              }}
              callback={(data) => {
                if (item?.id && popupType === "edit") {
                  handleOpenEmailModal(data);
                  return;
                }
                callback && callback(data);
                if (popupType !== "edit" && popupType !== "edit-request" && popupType !== "client-portal") {
                  handleOpenSecondModal(data);
                }
                onClose && onClose();
              }}
              onUpdateSuccess={handleOpenEmailModal}
              show={show}
              popupType={popupType}
            />
          </div>
        </div>
      </BootstrapDialog>

      {/* <div className={`modal fade`} id="addAppointmentPopUp" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="addAppointmentPopUpLabel" aria-hidden="true" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content full_modal">
            <div className="modal-header header_modal align-items-center">
              <div></div>
              <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Appointment</h5>
             
            </div>
            <div className="modal-body modal_form_body">
              {
                <AddAppointmentForm item={item}
                  handleClose={() => {
                    closeModalRef.current.click();
                    onClose && onClose();
                  }}
                  callback={(data) => {
                    callback();

                    handleOpenSecondModal(data)
                    closeModalRef.current.click();
                    onClose && onClose();

                  }}
                  show={show}
                />}
            </div>
          </div>
        </div>
      </div> */}
    </React.Fragment>
  );
}
//#endregion

export default AddAppointment
